module.exports = __webpack_public_path__ + "static/media/eye-open.c7c2e1db.svg";